import { CameraCapture } from "./AR/CameraCapture";
import { DeviceOrientationController } from "./AR/DeviceOrientationController";

AFRAME.registerSystem("ar-camera", {
  init: function () {
    this.sceneEl = window.APP.scene;
    this.initRenderer = this.initRenderer.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.initCamera = this.initCamera.bind(this);
    this.connectOrientation = this.connectOrientation.bind(this);

    window.addEventListener("resize", this.onWindowResize, false);
  },
  async initCamera() {
    await this.initRenderer();
    this.cameraPOV = null;
    this.orientation = null;
  },
  initRenderer() {
    const renderer = AFRAME?.scenes[0]?.renderer;
    this.capture = new CameraCapture(renderer, window, this.sceneEl.object3D);
  },
  async cameraStart() {
    await this.capture.start({ width: 1280, height: 720 });
  },
  cameraStop() {
    this.capture.stop();
  },
  getBrowserCamera() {
    return new Promise((resolve, reject) => {
      const videoDevices = [];

      navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (device.kind === "videoinput") {
              videoDevices.push({
                value: device.deviceId,
                text: device.label || "camera " + (i + 1)
              });
            }
          }
          resolve(videoDevices);
        })
        .catch(error => {
          console.error("Error enumerating devices:", error);
          reject(error);
        });
    });
  },
  onWindowResize() {
    if (this.capture) {
      const w = window.innerWidth;
      const h = window.innerHeight;

      this.capture?.resize(w, h);
    }
  },
  async connectOrientation() {
    const isMobile = AFRAME.utils.device.isMobile();
    if (isMobile && !this.cameraPOV && document.querySelector(".camera")) {
      this.cameraPOV = document.querySelector(".camera")?.object3D;
      this.orientation = new DeviceOrientationController(this.cameraPOV);
      await this.orientation.connect();
    }
  },
  tick(dt) {
    if (this.orientation) {
      this.orientation.update();
    }
    if (this.capture && this.capture?.cameraStarted) {
      this.capture.update();
    }
  }
});
